

























































import Vue from 'vue';
import { pick } from 'lodash';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { getConvertkitTags } from '@/web/services/convert-kit';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    TopNav,
  },
  data() {
    return {
      logo: '/assets/images/integrations/convertkit@3x.png',
      emailProvidersInfo: null,
      convertkitTags: null,
      convertkitTagSelected: null,
      isLoading: true,
      inProgress: false,
    };
  },
  methods: {
    async refreshConvertkit() {
      this.emailProvidersInfo = await this.$store.dispatch(
        'setting/getEmailProvider'
      );
      this.checkConvertkitStatus();
      if (this.emailProvidersInfo?.convertkit_api_key) {
        try {
          this.convertkitTags = await this.$store.dispatch(
            'setting/getConvertKitTags'
          );
          const { convertkit_default_tag } = this.emailProvidersInfo;
          this.convertkitTagSelected = this.convertkitTags.tags.find(
            tag => tag.id == convertkit_default_tag
          );
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorToMessage(error.response),
          });
        }
      }
    },
    async checkConvertkitStatus() {
      const key = this.emailProvidersInfo.convertkit_api_key;
      const secretKey = this.emailProvidersInfo.convertkit_api_secret;
      if (!key || !secretKey) {
        this.isConnected = false;
        return;
      }
      try {
        await getConvertkitTags(key);
        this.isConnected = true;
      } catch (error) {
        console.error(error);
        this.isConnected = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
    },
    async updateConvertkit() {
      this.inProgress = true;
      const data = pick(this.emailProvidersInfo, [
        'convertkit_api_key',
        'convertkit_api_secret',
        'convertkit_default_tag',
      ]);
      data.email_provider = 'convertkit';
      await this.$store.dispatch('setting/updateEmailProviderInfo', data);
      await this.refreshConvertkit();
      this.inProgress = false;
    },
    selectConvertKitTag(tag) {
      this.convertkitTagSelected = tag;
      this.emailProvidersInfo.convertkit_default_tag = tag?.id;
    },
    removeConvertkit() {
      console.log('removeConvertkit');
    },
  },
  async mounted() {
    await this.refreshConvertkit();
    this.isLoading = false;
  },
});
